import { Station } from '@mi-front/core';
import { useRouteMatch } from 'react-router-dom';
import { AuditMatchCategoryNavigator } from '../../components/AuditMatchCategoryNavigator';
import { MatchCategory } from '../matches-list/types';
import { ScheduleStatusAdsView } from './components/ads/ScheduleStatusAdsView';
import { ScheduleStatusPntView } from './components/pnt/ScheduleStatusPntView';

interface Props {
  readonly station: Station;
}

export function ScheduleStatusRootView({ station }: Props) {
  const match = useRouteMatch();

  return (
    <div>
      <AuditMatchCategoryNavigator>
        {(category) =>
          category === MatchCategory.ADS ? (
            <ScheduleStatusAdsView station={station} />
          ) : (
            <ScheduleStatusPntView station={station} />
          )
        }
      </AuditMatchCategoryNavigator>
    </div>
  );
}
